import React, { useEffect, useState } from 'react';
import Classes from '../Forms.module.scss';
import useAuth from '../../../hooks/useAuth';
import { Button, Spinner } from 'react-bootstrap';
import UtilityService from '../../../services/UtillityServices/UtilityService';
import { decodeToken } from 'react-jwt';
import { ROLES } from '../../../model/roles';
import { useNavigate } from 'react-router';
import { alertService } from '../../../services/AlertService';

function CompleteProfileForm({fetchCompleteProfile, setCompleteProfile}) {
    const {isLoading, completeProfile, login, loadingState} = useAuth();
    const [currentSection, setCurrentSection] = useState(1);
    const options = ["Sig.", "Sig.ra", "Prof.", "Prof.ssa", "Dott.", "Dott.ssa", "Geom.", "Rag.", "Ing.", "Arch.", "Per.", "Avv.", "Ing.", "Cav."];
    const [selectedTitleOption, setSelectedTitleOption] = useState(options[0]);
    const [selectedGender, setSelectedGender] = useState('M'); 
    const userToken = decodeToken(fetchCompleteProfile?.access_token);
    const [selectedProfileType, setSelectedProfileType] = useState('student'); 
    const [optionsArray, setOptionsArray] = useState([]);
    const [isEnabledShippingForm, setIsEnabledShippingForm] = useState(false);
    const [documentoRiconoscimento, setDocumentoRiconoscimento] = useState(null);//NEW
    const [codiceFiscaleFile, setCodiceFiscaleFile] = useState(null);//NEW
    const [documentoRiconoscimentoRetro, setDocumentoRiconoscimentoRetro] = useState(null);
    const [codiceFiscaleRetro, setCodiceFiscaleRetro] = useState(null);
    const navigate = useNavigate();
    
    useEffect(() => {
        setOptionsArray(options);
    }, []);      

    const [formData, setFormData] = useState({
      nome: userToken?.given_name || '',
      cognome: userToken?.family_name || ''
  });
    
    const handleChange = e => {
        const { name, value } = e.target;
        setFormData(prevState => ({ ...prevState, [name]: value }));
        if (currentSection === 2 && name.startsWith('fatturazione_')) {
            const shippingFieldName = name.replace('fatturazione_', 'spedizione_');
            setFormData(prevState => ({ ...prevState, [shippingFieldName]: value }));
        }
    };

    const onCompleteProfile = async () => {
      const userToken = decodeToken(fetchCompleteProfile?.access_token);
      if(userToken.role === ROLES.CORSISTA) { 
        if(currentSection === 3){
          const requiredFields = ["spedizione_nominativo", "spedizione_citta", "spedizione_indirizzo", "spedizione_provincia", "spedizione_cap"];
          const missingFields = UtilityService.validationForm(formData, requiredFields);
          if (missingFields?.length > 0) {
            const formatFields = missingFields?.map(field => {
              let formattedField = field.replace(/^spedizione_/, ""); 
              formattedField = formattedField.replace("citta", "città"); 
              return formattedField;
            });
            const formattedMissingFields = formatFields.join(", ");
              alertService.warn(`I seguenti campi sono obbligatori ${formattedMissingFields}`, {autoClose: true});
              return;
          }
        }
       }

      let obj = {
        ...formData,
        username: fetchCompleteProfile?.username,
        sesso: selectedGender,
        titolo: selectedTitleOption,
        fatturazioneBy: selectedProfileType,
     };
     obj.documentoRiconoscimento = documentoRiconoscimento;
     obj.codiceFiscale = codiceFiscaleFile;
     obj.documentoRiconoscimentoRetro = documentoRiconoscimentoRetro;
     obj.codiceFiscaleRetro = codiceFiscaleRetro;
     const res = await completeProfile(obj, fetchCompleteProfile.access_token);
     if(res) {
      const objLogin = {username: fetchCompleteProfile?.username,  password: fetchCompleteProfile?.newPassword || fetchCompleteProfile?.password}
      const respLogin = await login(objLogin);
      if(respLogin) {
        setCompleteProfile(null);
        localStorage.setItem("token", respLogin?.access_token)
        localStorage.setItem("refresh_token", respLogin?.refresh_token)
        const token = decodeToken(respLogin?.access_token);
        if(token.role === ROLES.CORSISTA) {
            navigate("/corsi")
        } else if (token.role === ROLES.ADMIN || token.role === ROLES.COURSE_DESIGNER || token.role === ROLES.DEVELOPER || token.role === ROLES.DOCENTE) {
            navigate("/gestione-corsi")
        } else if(token.role === ROLES.PARTNER){
            navigate("/gestione-utenti")
        } else if(token.role === ROLES.TUTOR){
            navigate("/area-personale/classi")
        }
        }
      }
    }
    
    const handleSelectChange = (event) => {
      setSelectedTitleOption(event.target.value);
    };

    
    const handleGenderChange = (event) => {
        setSelectedGender(event.target.value);
    };

    const handleselectedProfileTypeChange = (event) => {
        setSelectedProfileType(event.target.value);
    };

    const handleNextSection = () => {
      const userToken = decodeToken(fetchCompleteProfile?.access_token);
    
      if(currentSection === 1){
        const requiredFields = ["nome", "cognome", "data_nascita", "luogo_nascita", "provincia_nascita", "telefono1"];
        const missingFields = UtilityService.validationForm(formData, requiredFields);
        if (missingFields?.length > 0) {
          const formatFields = missingFields?.map(field => {
            let formattedField = field.replace(/_/g, " di ");
            formattedField = formattedField.replace("telefono1", "numero di telefono 1"); 
            return formattedField;
          });
          const formattedMissingFields = formatFields.join(", ");
          
          alertService.warn(`I seguenti campi sono obbligatori: ${formattedMissingFields}`, {autoClose: true});
          return;
        }
        if (!documentoRiconoscimento || !codiceFiscaleFile) {
          alertService.warn("È necessario caricare entrambi i documenti.", { autoClose: true });
          return;
        }        
      }

      if(userToken.role === ROLES.CORSISTA) {
        if(currentSection === 2){
          const requiredFields = ["fatturazione_nominativo", "fatturazione_citta", "fatturazione_indirizzo", "fatturazione_provincia", "fatturazione_cap", "fatturazione_piva"];
          const missingFields = UtilityService.validationForm(formData, requiredFields);
          if (missingFields?.length > 0) {
              const formatFields = missingFields?.map(field => {
                let formattedField = field.replace(/^fatturazione_/, ""); 
                formattedField = formattedField.replace("citta", "città"); 
                formattedField = formattedField.replace("piva", "codice fiscale"); 
                return formattedField;
              });
              const formattedMissingFields = formatFields.join(", ");
              alertService.warn(`I seguenti campi sono obbligatori: ${formattedMissingFields}`, {autoClose: true});
              return;
          }
        }
      }

      setCurrentSection(currentSection + 1);
    };
  
    const handlePrevSection = () => {
      setCurrentSection(currentSection - 1);
    };
  
    const renderSection = (section) => {
      if(userToken.role === ROLES.CORSISTA) {
        switch (section) {
          case 1:
            return renderFirstSection();
          case 2:
            return renderSecondSection();
          case 3:
            return renderThirdSection();
          default:
            return null;
        }
      } else {
        switch (section) {
          case 1:
            return renderFirstSection();
          default:
            return null;
        }
      }
    };

    const renderProgressBar = (perc) => {
        return (
          <div className="progress" role="progressbar" aria-valuemin="0" aria-valuemax="100">
            <div className="progress-bar bg-primary" style={{'width': `${perc}%`}}></div>
          </div>
        )
    }

    const handleCheckboxShippingChange = () => {
        setIsEnabledShippingForm(!isEnabledShippingForm);
    };

    const renderFirstSection = () => {
      const progressBar = userToken?.role === ROLES.CORSISTA ? 33 : 100;
        return (
            <div className="section" id="section1">
             {renderProgressBar(progressBar)}
            <h3 className="my-4"><b><i>Completa il tuo profilo</i></b></h3>
            <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                <input type="radio" className="btn-check" name="gender" id="maschio" autoComplete="off" value="M" checked={selectedGender === 'M'} onChange={handleGenderChange} />
                <label className="btn btn-outline-primary" htmlFor="maschio">Uomo</label>
                <input type="radio" className="btn-check" name="gender" id="femmina" autoComplete="off" value="F" checked={selectedGender === 'F'} onChange={handleGenderChange} />
                <label className="btn btn-outline-primary" htmlFor="femmina">Donna</label>
            </div>
          <div className="row">
              <div className="col-md-6">
                <div className="row my-4">
                  <div className="col-sm-3">
                  <select className="form-control py-3" id="titolo" onChange={handleSelectChange}>
                    {optionsArray?.map((option, index) => (
                    <option key={index} value={option}>{option}</option>
                    ))}
                </select>
                  </div>
                  <div className="col-sm-9">
                    <div className="form-floating">
                         <input type="text" className="form-control" name="nome" value={formData.nome} onChange={handleChange} id="firstName" placeholder="Nome" />
                         <label htmlFor="firstName">Nome</label>
                       </div>
                  </div>
                </div>
                   <div className="form-floating my-4">
                     <input type="text" className="form-control" name="cognome" value={formData.cognome} onChange={handleChange} id="lastName"  placeholder="Cognome" />
                     <label htmlFor="lastName">Cognome</label>
                   </div>
                 <div className="form-floating my-4">
                     <input type="date" className="form-control" name="data_nascita" value={formData.data_nascita || ''} onChange={handleChange}  required id="dateOfBirth" placeholder="Data di nascita" />
                     <label htmlFor="dateOfBirth">Data di nascita</label>
                   </div>
              </div>
              <div className="col-md-6">
                 <div className="form-floating my-4">
                     <input type="text" className="form-control" name="luogo_nascita" value={formData.luogo_nascita || ''} onChange={handleChange} required id="placeOfBirth" placeholder="Luogo di nascita" />
                     <label htmlFor="placeOfBirth">Città di nascita</label>
                   </div>
                 <div className="form-floating my-4">
                     <input type="text" className="form-control" name="provincia_nascita" value={formData.provincia_nascita || ''} onChange={handleChange} required id="provinceOfBirth" placeholder="Provincia di nascita" />
                     <label htmlFor="provinceOfBirth">Provincia di nascita</label>
                   </div>
                    <div className="row my-4">
                      <div className="col-sm-6">
                        <div className="form-floating">
                          <input type="number" className="form-control"  name="telefono1" value={formData.telefono1 || ''} onChange={handleChange} required  id="telephone1" placeholder="Numero di telefono 1" />
                          <label htmlFor="telephone1">Numero di telefono 1</label>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-floating">
                          <input type="number" className="form-control" name="telefono2" value={formData.telefono2 || ''} onChange={handleChange} required id="telephone2" placeholder="Numero di telefono 2" />
                          <label htmlFor="telephone2">Numero di telefono 2</label>
                        </div>
                      </div>
                    </div>
              </div>
              
              <div className="col-md-6 form-group my-4">
                      <label className="form-label"><b>Carica documento di riconoscimento (Fronte)</b></label>
                      <input
                          type="file"
                          className="form-control"
                          accept=".pdf,.jpg,.jpeg,.png"
                          onChange={(e) => setDocumentoRiconoscimento(e.target.files[0])}
                      />
                      {documentoRiconoscimento && <p className="mt-1"><i>File selezionato:</i><b> {documentoRiconoscimento.name}</b></p>}
                  </div>
                  <div className="col-md-6 form-group my-4">
                      <label className="form-label"><b>Carica documento di riconoscimento (Retro)</b></label>
                      <input
                          type="file"
                          className="form-control"
                          accept=".pdf,.jpg,.jpeg,.png"
                          onChange={(e) => setDocumentoRiconoscimentoRetro(e.target.files[0])}
                      />
                      {documentoRiconoscimentoRetro && <p className="mt-1"><i>File selezionato:</i><b> {documentoRiconoscimentoRetro.name}</b></p>}
                  </div>
              </div>

              <div className="row">
                  {/* --- SEZIONE CODICE FISCALE MODIFICATA --- */}
                  <div className="col-md-6 form-group my-4">
                      <label className="form-label"><b>Carica codice fiscale (Fronte)</b></label>
                      <input
                          type="file"
                          className="form-control"
                          accept=".pdf,.jpg,.jpeg,.png"
                          onChange={(e) => setCodiceFiscaleFile(e.target.files[0])}
                      />
                      {codiceFiscaleFile && <p className="mt-1"><i>File selezionato:</i><b> {codiceFiscaleFile.name}</b></p>}
                  </div>
                  <div className="col-md-6 form-group my-4">
                      <label className="form-label"><b>Carica codice fiscale (Retro)</b></label>
                      <input
                          type="file"
                          className="form-control"
                          accept=".pdf,.jpg,.jpeg,.png"
                          onChange={(e) => setCodiceFiscaleRetro(e.target.files[0])}
                      />
                      {codiceFiscaleRetro && <p className="mt-1"><i>File selezionato:</i><b> {codiceFiscaleRetro.name}</b></p>}
                  </div>

          </div>
      </div>
       )
    }

    const renderSecondSection = () => {
        return (
            <div className="section" id="section2">
                 {renderProgressBar(66)}
                <h3 className="my-4"><b><i>Dati fatturazione</i></b></h3>
                <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                    <input type="radio" className="btn-check" name="selectedProfileType" id="corsista" autoComplete="off" value="student" checked={selectedProfileType === 'student'} onChange={handleselectedProfileTypeChange} />
                    <label className="btn btn-outline-primary" htmlFor="corsista">Studente</label>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-floating my-4">
                            <input type="text" className="form-control" name="fatturazione_nominativo" value={formData.fatturazione_nominativo || ''} onChange={handleChange} id="name-company" placeholder="Nominativo/Ragione sociale" />
                            <label htmlFor="name-company">Nominativo</label>
                        </div>
                        <div className="form-floating my-4">
                            <input type="text" className="form-control" name="fatturazione_indirizzo" value={formData.fatturazione_indirizzo || ''} onChange={handleChange} id="address" placeholder="Indirizzo" />
                            <label htmlFor="address">Indirizzo</label>
                        </div>
                        <div className="form-floating my-4">
                            <input type="text" className="form-control" name="fatturazione_cap" value={formData.fatturazione_cap || ''} onChange={handleChange} id="CAP" placeholder="CAP" />
                            <label htmlFor="CAP">CAP</label>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-floating my-4">
                            <input type="text" className="form-control" name="fatturazione_citta" value={formData.fatturazione_citta || ''} onChange={handleChange} id="city" placeholder="Città" />
                            <label htmlFor="city">Città</label>
                        </div>
                        <div className="form-floating my-4">
                            <input type="text" className="form-control" name="fatturazione_provincia" value={formData.fatturazione_provincia || ''} onChange={handleChange} id="province" placeholder="province" />
                            <label htmlFor="province">Provincia</label>
                        </div>
                        <div className="form-floating my-4">
                            <input type="text" className="form-control" name="fatturazione_piva" value={formData.fatturazione_piva || ''} onChange={handleChange} id="pIva" placeholder="P.Iva/Codice fiscale" />
                            <label htmlFor="pIva">Codice fiscale</label>
                        </div>
                    </div>
                </div>
          </div>
        )
    }

    const renderThirdSection = () => {
        return (
            <div className="section" id="section3">
                   {renderProgressBar(100)}
                <h3 className="my-4"><b><i>Dati Spedizione</i></b></h3>
                <div className="btn-group" role="group" aria-label="Basic checkbox toggle button group">
                    <input type="checkbox" className="btn-check" name='btnradio3' id="cambia-dati" autoComplete="off" onChange={handleCheckboxShippingChange}/>
                    <label className="btn btn-outline-primary" htmlFor="cambia-dati">Cambia dati</label>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-floating my-4">
                            <input type="text" className="form-control form-dati-spedizione" name="spedizione_nominativo" value={formData.spedizione_nominativo || ''} onChange={handleChange} id="name-company-shipping" placeholder="Nominativo/Ragione sociale" disabled={!isEnabledShippingForm} />
                            <label htmlFor="name-company-shipping">Nominativo</label>
                        </div>
                        <div className="form-floating my-4">
                            <input type="text" className="form-control form-dati-spedizione" name="spedizione_indirizzo" value={formData.spedizione_indirizzo || ''} onChange={handleChange} id="address-shipping" placeholder="Indirizzo" disabled={!isEnabledShippingForm} />
                            <label htmlFor="address-shipping">Indirizzo</label>
                        </div>
                        <div className="form-floating my-4">
                            <input type="text" className="form-control form-dati-spedizione" name="spedizione_cap" value={formData.spedizione_cap || ''} onChange={handleChange} id="CAP-shipping" placeholder="CAP" disabled={!isEnabledShippingForm} />
                            <label htmlFor="CAP-shipping">CAP</label>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-floating my-4">
                            <input type="text" className="form-control form-dati-spedizione" name="spedizione_citta" value={formData.spedizione_citta || ''} onChange={handleChange} id="city-shipping" placeholder="Città" disabled={!isEnabledShippingForm} />
                            <label htmlFor="city-shipping">Città</label>
                        </div>
                        <div className="form-floating my-4">
                            <input type="text" className="form-control form-dati-spedizione" name="spedizione_provincia" value={formData.spedizione_provincia || ''} onChange={handleChange} id="province-shipping" placeholder="province" disabled={!isEnabledShippingForm} />
                            <label htmlFor="province-shipping">Provincia</label>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
  
    return (
      <div className="d-flex align-items-center justify-content-center my-5">
        <div className="container complete-profile shadow rounded fade-in-top mb-3">
          <div className={`row ${Classes.completeProfileBg} p-5`}>
            <div className={`col-md-3 `}>
            </div>
            <div className={`col-md-9 complete-profile-right rounded shadow ${Classes.completeProfileForm} p-4`}>
                  <div>
                    {renderSection(currentSection)}
                    <div className={`d-flex ${(currentSection === 1) ? 'justify-content-end': 'justify-content-between'}`}>
                      {(currentSection !== 1 && userToken.role === ROLES.CORSISTA) && (
                        <button
                          type="button"
                          className="btn btn-secondary prev-section btn-lg"
                          onClick={handlePrevSection}
                        >
                          Indietro
                        </button>
                      )}
                      {(currentSection !== 3 && userToken.role === ROLES.CORSISTA) && (
                        <button
                          type="button"
                          className="btn btn-primary next-section btn-lg"
                          onClick={handleNextSection}
                        >
                          Avanti
                        </button>
                      )}
                      {(currentSection === 3 || userToken.role !== ROLES.CORSISTA) && (
                        isLoading || loadingState.isLoadingLogin ? (
                          <Button variant="primary" disabled className="btn btn-primary next-section btn-lg">
                              <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                  className="me-2"
                              />
                              Completa profilo...
                          </Button>
                          ) : (
                              <Button type="button" onClick={onCompleteProfile} className="btn btn-primary next-section btn-lg">
                                  Completa profilo
                              </Button>
                          )
                      )}
                    </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
    );
}

export default CompleteProfileForm